import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66cc2af4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BoardItem__content" }
const _hoisted_2 = {
  key: 0,
  class: "content__transfer"
}
const _hoisted_3 = { class: "content__title" }
const _hoisted_4 = { class: "content__text" }
const _hoisted_5 = { class: "content__text" }
const _hoisted_6 = { class: "BoardItem__actions justify-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "9",
  height: "10",
  viewBox: "0 0 9 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.57983 7.97674C2.62125 7.97674 1.84104 7.19658 1.84104 6.23807V2.04492H1.12511C0.504459 2.04492 0 2.54927 0 3.16988V8.69262C0 9.31323 0.504459 9.81765 1.12511 9.81765H6.23906C6.85971 9.81765 7.36417 9.31323 7.36417 8.69262V7.97674H3.57983Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.99903 1.12503C8.99903 0.5036 8.49539 0 7.874 0H3.57823C2.95676 0 2.45312 0.5036 2.45312 1.12503V6.23864C2.45312 6.86006 2.95676 7.36366 3.57823 7.36366H7.874C8.49539 7.36366 8.99903 6.86006 8.99903 6.23864V1.12503Z",
    fill: "white"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "BoardItem__tooltip"
}
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pre_trip_status_icon = _resolveComponent("pre-trip-status-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BoardItem", { 'BoardItem--red': _ctx.item.status.id === 3, 'BoardItem--yellow': _ctx.item.status.id === 6 }]),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDetails && _ctx.openDetails(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.item.rescheduleDate && _ctx.item.status.id === 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Перенесен с " + _toDisplayString(_ctx.item.rescheduleDate), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item.direction.fromCity.name) + " - " + _toDisplayString(_ctx.item.direction.whereCity.name), 1),
      _createElementVNode("div", _hoisted_4, "Физ. вес: " + _toDisplayString(_ctx.item.totalWeight) + " кг", 1),
      _createElementVNode("div", _hoisted_5, "Кубатура: " + _toDisplayString(_ctx.item.totalCubature), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.isCanTransfer)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "flex items-center justify-center",
            style: { backgroundColor: '#0263E0', padding: '3px 4px', borderRadius: '4px' },
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openTransfer && _ctx.openTransfer(...args)), ["stop"]))
          }, _hoisted_8))
        : _createCommentVNode("", true),
      _createVNode(_component_pre_trip_status_icon, {
        status: _ctx.item.status
      }, null, 8, ["status"])
    ]),
    (Boolean(_ctx.item.comment) && (_ctx.item.status.id === 5 || _ctx.item.status.id === 6))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", null, _toDisplayString(_ctx.item.comment?.commentName) + ":", 1),
          (_ctx.item.comment?.message)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.item.comment.message), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}